import { render, staticRenderFns } from "./MiuVipOrderDetail.vue?vue&type=template&id=882725f2&scoped=true"
import script from "./MiuVipOrderDetail.vue?vue&type=script&lang=js"
export * from "./MiuVipOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./MiuVipOrderDetail.vue?vue&type=style&index=0&id=882725f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882725f2",
  null
  
)

export default component.exports